import { createPortal } from "react-dom";
import { toast } from "sonner";
import { X, Download, Copy } from "lucide-react";
import { yellowBtn } from "@/lib/airep";

const LinkRow = ({ label, hint, url, testid }) => (
  <div className="space-y-1">
    <div className="text-sm font-semibold">{label}</div>
    <div className="flex gap-2">
      <input readOnly value={url} className="flex-1 min-w-0 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-xs font-mono" data-testid={`${testid}-url`} />
      <button onClick={() => { navigator.clipboard.writeText(url); toast.success("Link copiato"); }} className={`${yellowBtn} px-3 py-2 text-sm`} data-testid={`${testid}-copy`}><Copy className="h-4 w-4" /> Copia</button>
    </div>
    <p className="text-xs text-slate-500">{hint}</p>
  </div>
);

export const DeckLinksModal = ({ deck, onClose }) => {
  const qr = `${process.env.REACT_APP_BACKEND_URL}/api/airep/join/${deck.code}/qr.png`;
  const download = async () => {
    const blob = await (await fetch(qr)).blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `QR-${deck.title.replace(/[^\w-]+/g, "_")}.png`;
    a.click();
    URL.revokeObjectURL(a.href);
  };
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/50 grid place-items-center p-4" onClick={onClose} data-testid="deck-links-modal">
      <div className="bg-white rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6 space-y-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <h3 className="font-display font-bold text-xl">QR e link per le tue slide</h3>
            <p className="text-sm text-slate-500 mt-1">"{deck.title}" · codice fisso <span className="font-mono font-bold">{deck.code}</span></p>
          </div>
          <button onClick={onClose} className="h-9 w-9 grid place-items-center rounded-xl bg-[#E3FF00]" aria-label="Chiudi" data-testid="deck-links-close"><X className="h-4 w-4" /></button>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <img src={qr} alt="QR del sondaggio" className="h-40 w-40 rounded-xl border border-slate-200" data-testid="deck-links-qr" />
          <div className="space-y-2 text-sm text-slate-600">
            <p>Questo QR non cambia: mettilo nella slide del sondaggio. Prima dell'avvio il pubblico vede "Il sondaggio sta per iniziare" e la pagina si apre da sola quando parti.</p>
            <button onClick={download} className={`${yellowBtn} px-4 py-2 text-sm`} data-testid="deck-links-download"><Download className="h-4 w-4" /> Scarica QR</button>
          </div>
        </div>
        <LinkRow label="Link per il pubblico" hint="Per chi non può inquadrare il QR." url={`${window.location.origin}/r/${deck.code}`} testid="deck-links-public" />
        <LinkRow label="Link per te (avvia il sondaggio)" hint="Mettilo come collegamento nella tua slide: apre la schermata del sondaggio già avviata. Se è già in corso la riprende. Serve essere connessi a Mypasspartu su quel computer." url={`${window.location.origin}/ai-report/go/${deck.id}`} testid="deck-links-presenter" />
      </div>
    </div>,
    document.body,
  );
};
